<template>
  <v-container grid-list-md fluid>
    <h2>クライアント管理</h2>
    <v-layout row　align-center>
      <v-flex md3>
        <v-btn @click="addItem">
          <v-icon>add</v-icon>追加
        </v-btn>
      </v-flex>
    </v-layout>
    <v-spacer></v-spacer>
    <v-dialog v-model="dialog">
      <edit-item v-if="dialog" @closeDialog="closeDialog" @createItem="createItem" @updateItem="updateItem" v-model="selectedItem" :action="action" />
      <v-alert :value="errorMessage.length>0">{{errorMessage}}</v-alert>
    </v-dialog>
    <v-data-table :headers="headers" :items="items" :search="search" class="elevation-1" :pagination.sync="pagination" rows-per-page-text="表示行">
      <template slot="items" slot-scope="props">
        <tr @click="toManageSurvey(props.item)">
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ toStaffs(props.item.staffs) }}</td>
          <td class="text-xs-left">{{ toYears(props.item.years) }}</td>
          <td class="text-xs-left">{{ props.item.listed}}</td>
          <td class="text-xs-left">{{ props.item.classification}}</td>
          <td>
            <v-btn icon @click.stop="editItem(props.item)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn icon @click="deleteItem(props.item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <template slot="pageText" slot-scope="props">
        {{ props.itemsLength }} 件中 {{ props.pageStart }} - {{ props.pageStop }} 件表示
      </template>
    </v-data-table>

  </v-container>
</template>

<script>

import db from '@/components/firebaseInit'
import auth from '@/components/fireAuthInit'
import EditItem from "@/components/companies/editCompany.vue"
import { mapMutations } from 'vuex'
import { getMoment} from "@/utils/datetime.js"
export default {
  components: {
    EditItem
  },
  data() {
    return {
      items: [],
      dbRef: db.collection("companies"),
      action: "add",
      dialog: false,
      selectedItem: {},
      newItem: { classification: 0, id: "", listed: "", name: "", staffs: 0, years: 0 },
      errorMessage: "",
      headers: [
        {
          text: '顧客名',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        {
          text: '社員数',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        {
          text: '創業年数',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        {
          text: '上場・非上場',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        {
          text: '業種',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: '操作', sortable: false },
      ],
      file: null,
      pagination: {
        rowsPerPage: 50
      },
      search: "",
      staffsOptions: [
        { value: 1, text: "5人未満" },
        { value: 2, text: "5～ 29人" },
        { value: 3, text: "30～ 99人" },
        { value: 4, text: "100～299人" },
        { value: 5, text: "300～999人" },
        { value: 6, text: "1,000人以上" },
      ],
      listedOptions: ["非上場", "上場"],
    }

  },
  mounted() {
    this.changeLoadingState(true)

    this.reloadItems()
  },
  methods: {
    async reloadItems() {
      this.changeLoadingState(true)
      this.items = []
      const items = await this.dbRef.get()
      items.forEach((doc) => {
        this.items.push({ ...doc.data(), id: doc.id })
      })
      this.changeLoadingState(false)
    },
    closeDialog() {
      this.errorMessage = ""
      this.dialog = false
    },
    async createItem() {
      try {
        await this.dbRef.add(this.selectedItem)
        this.closeDialog()
        this.reloadItems()
      } catch (e) {
        //this.errorMessage = authErrorCodeToMessage(e.code)
        console.log(e)

      }
    },
    editItem(item) {
      this.selectedItem = JSON.parse(JSON.stringify(item))
      this.action = "update"
      this.dialog = true
    },
    addItem() {
      this.selectedItem = JSON.parse(JSON.stringify(this.newItem))
      this.action = 'add'
      this.dialog = true
    },
    async deleteItem(item) {
      try {
        await this.dbRef.doc(item.id).delete()
        this.reloadItems()
      } catch (e) {
        console.log(e)
      }

    },
    async updateItem() {
      await this.dbRef.doc(this.selectedItem.id).set(this.selectedItem)
      this.closeDialog()
      this.reloadItems()
    },
    selectedFile(e) {
      e.preventDefault();
      this.file = e.target.files[0]
    },
    importFile() {
      this.changeLoadingState(true)
      const reader = new FileReader()
      reader.readAsArrayBuffer(this.file)
      reader.onload = (e) => {
        const data = new Uint8Array(reader.result)
        const workbook = XLSX.read(data, { type: "array" })
        const worksheet = workbook.Sheets[workbook.SheetNames[0]]
        const items = XLSX.utils.sheet_to_json(worksheet)
        this.createItems(items)
      }
    },
    async createItems(items) {
      const promises = []
      try {
        items.forEach(item => {
          const p = this.dbRef.doc(item.id).set(item)
          promises.push(p)
        })

      } catch (e) {
        //this.errorMessage = authErrorCodeToMessage(e.code)
        console.log(e)
      }
      await Promise.all(promises)
      this.reloadItems()
    },
    toStaffs(num) {
      const staffs = this.staffsOptions.find((e) => { return e.value == num })
      return staffs ? staffs.text : ""
    },
    toYears(num) {
      const moment = getMoment()
      const now = moment()
      const birth = moment([num,1,1])
      return now.diff(birth,'years') + 1
    },
    toManageSurvey(item) {
      this.$router.push({ name: "manage_surveys", params: { company_id: item.id} })
    },
    ...mapMutations('app', ['changeLoadingState'])
  },
  created: function () {
  }

}
</script>
<style lang="scss" scoped>
</style>
